import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetch as axios } from '../../axios_config';
import { handleRejectedResponse } from './utils';
import { findIndex, cloneDeep, filter, minBy, isArray } from 'lodash';
import { notification } from 'antd';

export const GetProducts = createAsyncThunk(
  '3-layer/products',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${process.env.OPULENT_NODE_API_URL}/products/get-products`,
        {
          params: data
        }
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Get Products', rejectWithValue);
    }
  }
);

export const GetUnitCostHistories = createAsyncThunk(
  '3-layer/unit-cost-histories',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${process.env.OPULENT_NODE_API_URL}/products/get-unit-cost-histories`,
        {
          params: data
        }
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Get Unit Cost Histories', rejectWithValue);
    }
  }
);

export const ExportFilteredProducts = createAsyncThunk(
  '3-layer/export-filtered-products',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${process.env.OPULENT_NODE_API_URL}/products/export-filtered`,
        {
          params: { ...data, exportAll: true }
        }
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Export Filtered Products', rejectWithValue);
    }
  }
);

export const GetSkuUnitCostHistories = createAsyncThunk(
  '3-layer/sku-unit-cost-histories',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${process.env.OPULENT_NODE_API_URL}/skus/get-sku-unit-cost-histories`,
        {
          params: data
        }
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Get SKU Unit Cost Histories', rejectWithValue);
    }
  }
);

export const GetSKUs = createAsyncThunk(
  '3-layer/skus',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${process.env.OPULENT_NODE_API_URL}/skus/get-skus`,
        {
          params: data
        }
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Get SKUs', rejectWithValue);
    }
  }
);

export const ExportSkuMapping = createAsyncThunk(
  '3-layer/export-sku-mapping',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${process.env.OPULENT_NODE_API_URL}/skus/export-sku-mapping`);
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Export Sku Mapping', rejectWithValue);
      }
  }
);
      
      
export const ExportFilteredSKUs = createAsyncThunk(
  '3-layer/export-filtered-skus',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${process.env.OPULENT_NODE_API_URL}/skus/export-filtered`,
        {
          params: { ...data, exportAll: true }
        }
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Export Filtered SKUs', rejectWithValue);
    }
  }
);

export const GetAsinsList = createAsyncThunk(
  '3-layer/asins-list',
  async (data, { rejectWithValue }) => {
    try {
      const { saveData } = data || {};
      delete data.saveData;

      const response = await axios.get(`${process.env.OPULENT_NODE_API_URL}/skus/asins-list`,
        {
          params: data
        }
      );

      return {
        ...response,
        data: { ...response?.data, saveData }
      };
    } catch (err) {
      return handleRejectedResponse(err, 'Get Asins List', rejectWithValue);
    }
  }
);

export const GetSkusList = createAsyncThunk(
  '3-layer/skus-list',
  async (data, { rejectWithValue }) => {
    try {
      const { saveData } = data || {};
      delete data?.saveData;

      const response = await axios.get(`${process.env.OPULENT_NODE_API_URL}/skus/skus-list`,
        {
          params: data
        }
      );

      return {
        ...response,
        data: { ...response?.data, saveData }
      };
    } catch (err) {
      return handleRejectedResponse(err, 'Get Skus List', rejectWithValue);
    }
  }
);

export const GetProductsList = createAsyncThunk(
  '3-layer/products-list',
  async (data, { rejectWithValue }) => {
    try {
      const { saveData } = data || {};
      delete data?.saveData;

      const response = await axios.get(`${process.env.OPULENT_NODE_API_URL}/products/products-list`,
        {
          params: data
        }
      );

      return {
        ...response,
        data: { ...response?.data, saveData }
      };
    } catch (err) {
      return handleRejectedResponse(err, 'Get Products List', rejectWithValue);
    }
  }
);

export const GetStats = createAsyncThunk(
  '3-layer/stats',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${process.env.OPULENT_NODE_API_URL}/skus/stats`);
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Get Stats', rejectWithValue);
    }
  }
);

export const GetVendorItems = createAsyncThunk(
  '3-layer/vendor-items',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${process.env.OPULENT_NODE_API_URL}/vendor-items/get-vendor-items`,
        {
          params: data
        }
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Get Vendor Items', rejectWithValue);
    }
  }
);

export const ExportFilteredVendorItems = createAsyncThunk(
  '3-layer/export-filtered-vendor-items',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${process.env.OPULENT_NODE_API_URL}/vendor-items/export-filtered`,
        {
          params: { ...data, exportAll: true }
        }
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Export Filtered Vendor Items', rejectWithValue);
    }
  }
);

export const AddUnitCost = createAsyncThunk(
  '3-layer/unit-cost/:vendor_item_id',
  async (data, { rejectWithValue }) => {
    try {
      const { vendorItemId } = data || {};
      delete data.vendorItemId;

      const response = await axios.post(`${process.env.OPULENT_NODE_API_URL}/skus/unit-cost/${vendorItemId}`,
        {
          ...data,
          active_date: new Date()
        }
      );

      return {
        ...response,
        data: { ...response?.data, vendorItemId }
      };
    } catch (err) {
      return handleRejectedResponse(err, 'Add Unit Cost', rejectWithValue);
    }
  }
);

export const AddProduct = createAsyncThunk(
  '3-layer/product',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${process.env.OPULENT_NODE_API_URL}/products/add-product`,
        data
      );

      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Add Product', rejectWithValue);
    }
  }
);

export const AddSku = createAsyncThunk(
  '3-layer/sku',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${process.env.OPULENT_NODE_API_URL}/skus/add-sku`,
        data
      );

      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Add SKU', rejectWithValue);
    }
  }
);

export const MapProducts = createAsyncThunk(
  '3-layer/map-products',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${process.env.OPULENT_NODE_API_URL}/skus/map-products`,
        data
      );

      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Map Products', rejectWithValue);
    }
  }
);

export const MapSkus = createAsyncThunk(
  '3-layer/map-skus',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${process.env.OPULENT_NODE_API_URL}/products/map-skus`,
        data
      );

      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Map SKUs', rejectWithValue);
    }
  }
);

export const UnLinkItem = createAsyncThunk(
  '3-layer/unlink-item',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.delete(`${process.env.OPULENT_NODE_API_URL}/skus/unlink-item`, {
        params: data
      });

      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Un-Link SKU', rejectWithValue);
    }
  }
);

export const EditProduct = createAsyncThunk(
  '3-layer/product',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.patch(`${process.env.OPULENT_NODE_API_URL}/products/edit-product`,
        data
      );

      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Edit Product', rejectWithValue);
    }
  }
);

export const EditItemQuantity = createAsyncThunk(
  '3-layer/edit-item-mapped-qty',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.patch(`${process.env.OPULENT_NODE_API_URL}/products/edit-item-mapped-qty`,
        data
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Edit Sku-Product Quantity', rejectWithValue);
    }
  }
);

export const CheckWorkOrderLinkStatus = createAsyncThunk(
  '3-layer/check-work-order-link',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${process.env.OPULENT_NODE_API_URL}/wo/check-work-order-link`,
        {
          params: data
        }
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Check Work Order Link Status', rejectWithValue);
    }
  }
);

export const UpdateVarietyPack = createAsyncThunk(
  'skus/update-variety-pack',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.patch(`${process.env.OPULENT_NODE_API_URL}/skus/update-variety-pack`,
        data
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Update Variety Pack', rejectWithValue);
    }
  }
)

export const SubmitListingsFeed = createAsyncThunk(
  'skus/submit-listings-feed',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${process.env.OPULENT_NODE_API_URL}/skus/submit-listings-feed`, data);
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Submit Listings Feed', rejectWithValue);
    }
  }
)

export const GetListingFeedStatus = createAsyncThunk(
  'skus/listing-feed-status',
  async ({ skuIds }, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${process.env.OPULENT_NODE_API_URL}/skus/listing-feed-status`, {
        params: { skuIds: skuIds.join(',') }
      });
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Get Listing Feed Status', rejectWithValue);
    }
  }
)

const threeLayerProducts = createSlice({
  name: "threeLayerProducts",
  initialState: {
    products: [],
    totalProductsCount: 0,
    fetchingProducts: false,

    skus: [],
    totalSKUsCount: 0,
    fetchingSKUs: false,

    vendorItems: [],
    totalVendorItemsCount: 0,
    fetchingVendorItems: false,

    addingUnitCost: false,
    addingProduct: false,
    addingSku: false,

    fetchingAsinsList: false,
    asinsList: [],
    totalAsinsListCount: 0,

    fetchingSkusList: false,
    skusList: [],
    totalSkusListCount: 0,

    fetchingProductsList: false,
    productsList: [],
    totalProductsListCount: 0,

    unLinkingItem: false,
    mappingSkus: false,
    mappingProducts: false,
    editingProduct: false,

    editingItemQuantity: false,
    mappingAlertData: [],
    mappingAlertErrorMsg: '',

    fetchingStats: false,
    stats: {},

    exportingData: false,
    checkingWorkOrderLinkStatus: false,
    updatingVarietyPack: false,
    fetchingUnitCostHistories: false,
    unitCostHistories: [],
    skuUnitCostHistories: [],
    submittingListingsFeed: false,
    listingStatuses: {},
  },
  reducers: {
    removeMappedItem(state, { payload: { field, parentId, key, childId } }) {
      const parentIndex = findIndex(state[field], ({ id }) => id === parentId);
      const filteredData = filter(state[field][parentIndex][key], ({ id }) => id !== childId);
      state[field][parentIndex][key] = filteredData;
    },
    updateMappedQuantity(state, { payload: { field, parentId, key, childId, value } }) {
      const parentIndex = findIndex(state[field], ({ id }) => id === parentId);
      const childIndex = findIndex(state[field][parentIndex][key], ({ id }) => id === childId);
      state[field][parentIndex][key][childIndex].product_sku_mappings_v2.bundle_quantity = value;
      if (field === 'skus') {
        const minValue = minBy(state[field][parentIndex][key], (item) => item.product_sku_mappings_v2.bundle_quantity);
        state[field][parentIndex].available_quantity = minValue?.product_sku_mappings_v2?.bundle_quantity || 0;
      }
    },
    clearField(state, { payload: { field } }) {
      state[field] = isArray(state[field]) ? [] : {};
    },
  },
  extraReducers: {
    [GetProducts.pending]: (state, action) => {
      const { exportAll } = action?.meta?.arg || {};
      if (!exportAll) {
        state.fetchingProducts = true;
      }
      else state.exportingData = true;
    },
    [GetProducts.fulfilled]: (state, action) => {
      const { exportAll } = action?.meta?.arg || {};
      if (!exportAll) {
        const { result, count } = action?.payload || {};
        state.fetchingProducts = false;
        state.products = result;
        state.totalProductsCount = count;
      }
      else state.exportingData = false;

    },
    [GetProducts.rejected]: (state, action) => {
      const { exportAll } = action?.meta?.arg || {};
      if (!exportAll) {
        state.fetchingProducts = false;
      }
      else state.exportingData = false;

    },

    [GetSKUs.pending]: (state, action) => {
      const { exportAll } = action?.meta?.arg || {};
      if (!exportAll) {
        state.fetchingSKUs = true;
      }
      else state.exportingData = true;
    },
    [GetSKUs.fulfilled]: (state, action) => {
      const { exportAll } = action?.meta?.arg || {};
      if (!exportAll) {
        const { result, count } = action?.payload || {};
        state.fetchingSKUs = false;
        state.skus = result;
        state.totalSKUsCount = count;
      }
      else state.exportingData = false;

    },
    [GetSKUs.rejected]: (state, action) => {
      const { exportAll } = action?.meta?.arg || {};
      if (!exportAll) {
        state.fetchingSKUs = false;
      }
      else state.exportingData = false;
    },

    [GetVendorItems.pending]: (state, action) => {
      const { exportAll } = action?.meta?.arg || {};
      if (!exportAll) {
        state.fetchingVendorItems = true;
      }
      else state.exportingData = true;
    },
    [GetVendorItems.fulfilled]: (state, action) => {
      const { exportAll } = action?.meta?.arg || {};
      if (!exportAll) {
        const { result, count } = action?.payload || {};
        state.fetchingVendorItems = false;
        state.vendorItems = result;
        state.totalVendorItemsCount = count;
      }
      else state.exportingData = false;

    },
    [GetVendorItems.rejected]: (state, action) => {
      const { exportAll } = action?.meta?.arg || {};
      if (!exportAll) {
        state.fetchingVendorItems = false;
      }
      else state.exportingData = false;

    },

    [AddUnitCost.pending]: (state) => {
      state.addingUnitCost = true;
    },
    [AddUnitCost.fulfilled]: (state, action) => {
      const { data, vendorItemId } = action?.payload?.data || {};
      const vendorItemsClone = cloneDeep(state.vendorItems);
      const index = findIndex(vendorItemsClone, ({ id }) => id === vendorItemId);
      vendorItemsClone[index].unit_cost_histories_v2.unshift(data);

      state.addingUnitCost = false;
      state.vendorItems = [...vendorItemsClone];
    },
    [AddUnitCost.rejected]: (state) => {
      state.addingUnitCost = false;
    },

    [AddProduct.pending]: (state) => {
      state.addingProduct = true;
    },
    [AddProduct.fulfilled]: (state, action) => {
      const { data, message, success } = action?.payload || {};

      state.addingSku = false;
      notification[success ? 'success' : 'error']({
        message,
        top: 65,
      });

      state.addingProduct = false;
    },
    [AddProduct.rejected]: (state) => {
      state.addingProduct = false;
    },

    [MapProducts.pending]: (state) => {
      state.mappingProducts = true;
    },
    [MapProducts.fulfilled]: (state, action) => {
      const { message, success } = action?.payload || {};

      state.mappingProducts = false;
      notification[success ? 'success' : 'error']({
        message,
        top: 65,
      });
    },
    [MapProducts.rejected]: (state, action) => {
      const { errorData, message } = action?.payload || {};

      state.mappingAlertData = errorData;
      state.mappingAlertErrorMsg = message;
      state.mappingProducts = false;
    },

    [MapSkus.pending]: (state) => {
      state.mappingSkus = true;
    },
    [MapSkus.fulfilled]: (state, action) => {
      const { message, success } = action?.payload || {};

      state.mappingSkus = false;
      notification[success ? 'success' : 'error']({
        message,
        top: 65,
      });
    },
    [MapSkus.rejected]: (state, action) => {
      const { errorData, message } = action?.payload || {};

      state.mappingAlertData = errorData;
      state.mappingAlertErrorMsg = message;
      state.mappingSkus = false;
    },

    [AddSku.pending]: (state) => {
      state.addingSku = true;
    },
    [AddSku.fulfilled]: (state, action) => {
      const { message, success } = action?.payload || {};

      state.addingSku = false;
      notification[success ? 'success' : 'error']({
        message,
        top: 65,
      });
    },
    [AddSku.rejected]: (state) => {
      state.addingSku = false;
    },

    [GetSkusList.pending]: (state) => {
      state.fetchingSkusList = true;
    },
    [GetSkusList.fulfilled]: (state, action) => {
      const { data, count, saveData } = action?.payload?.data || {};
      const previousList = [...state.skusList];

      state.skusList = !saveData ? [...data] : [...previousList, ...data];
      state.fetchingSkusList = false;
      state.totalSkusListCount = count;
    },
    [GetSkusList.rejected]: (state) => {
      state.fetchingSkusList = false;
    },

    [GetProductsList.pending]: (state) => {
      state.fetchingProductsList = true;
    },
    [GetProductsList.fulfilled]: (state, action) => {
      const { data, count, saveData } = action?.payload?.data || {};
      const previousList = [...state.productsList];

      state.productsList = !saveData ? [...data] : [...previousList, ...data];
      state.fetchingProductsList = false;
      state.totalProductsListCount = count;
    },
    [GetProductsList.rejected]: (state) => {
      state.fetchingProductsList = false;
    },

    [GetAsinsList.pending]: (state) => {
      state.fetchingAsinsList = true;
    },
    [GetAsinsList.fulfilled]: (state, action) => {
      const { data, count, saveData } = action?.payload?.data || {};

      const previousList = [...state.asinsList];
      const newList = data?.map(({ asin }) => asin) || [];

      state.fetchingAsinsList = false;
      state.totalAsinsListCount = count;
      state.asinsList = !saveData ? [...newList] : [...previousList, ...newList];
    },
    [GetAsinsList.rejected]: (state) => {
      state.fetchingAsinsList = false;
    },

    [GetStats.pending]: (state) => {
      state.fetchingStats = true;
    },
    [GetStats.fulfilled]: (state, action) => {
      const { data } = action?.payload || {};

      state.fetchingStats = false;
      state.stats = data;
    },
    [GetStats.rejected]: (state) => {
      state.fetchingStats = false;
    },

    [UnLinkItem.pending]: (state) => {
      state.unLinkingItem = true;
    },
    [UnLinkItem.fulfilled]: (state, action) => {
      const { message, success } = action?.payload || {};
      state.unLinkingItem = false;
      notification[success ? 'success' : 'error']({
        message,
        top: 65,
      });
    },
    [UnLinkItem.rejected]: (state, action) => {
      const { errorData, message } = action?.payload || {};

      state.mappingAlertData = errorData;
      state.mappingAlertErrorMsg = message;
      state.unLinkingItem = false;
    },

    [EditProduct.pending]: (state) => {
      state.editingProduct = true;
    },
    [EditProduct.fulfilled]: (state, action) => {
      const { message, success } = action?.payload || {};
      state.editingProduct = false;
      notification[success ? 'success' : 'error']({
        message,
        top: 65,
      });
    },
    [EditProduct.rejected]: (state) => {
      state.editingProduct = false;
    },

    [EditItemQuantity.pending]: (state) => {
      state.editingItemQuantity = true;
    },
    [EditItemQuantity.fulfilled]: (state, action) => {
      const { message, success } = action?.payload || {};
      state.editingItemQuantity = false;
      notification[success ? 'success' : 'error']({
        message,
        top: 65,
      });
    },
    [EditItemQuantity.rejected]: (state, action) => {
      const { errorData, message } = action?.payload || {};

      state.mappingAlertData = errorData;
      state.mappingAlertErrorMsg = message;
      state.editingItemQuantity = false;
    },

    [CheckWorkOrderLinkStatus.pending]: (state) => {
      state.checkingWorkOrderLinkStatus = true;
    },
    [CheckWorkOrderLinkStatus.fulfilled]: (state) => {
      state.checkingWorkOrderLinkStatus = false;
    },
    [CheckWorkOrderLinkStatus.rejected]: (state, action) => {
      const { errorData, message } = action?.payload || {};

      state.mappingAlertData = errorData;
      state.mappingAlertErrorMsg = message;
      state.checkingWorkOrderLinkStatus = false;
    },
    [UpdateVarietyPack.pending]: (state) => {
      state.updatingVarietyPack = true;
    },
    [UpdateVarietyPack.fulfilled]: (state, action) => {
      state.updatingVarietyPack = false;
      const { skuId, newVarietyPackStatus } = action?.meta?.arg || {};
      const index = findIndex(state.skus, ({ id }) => id === skuId);
      if (index > -1) {
        state.skus[index].is_variety_pack = newVarietyPackStatus;
      }
    },
    [UpdateVarietyPack.rejected]: (state) => {
      state.updatingVarietyPack = false;
    },
    [GetUnitCostHistories.pending]: (state) => {
      state.fetchingUnitCostHistories = true;
    },
    [GetUnitCostHistories.fulfilled]: (state, action) => {
      const { result } = action?.payload || {};
      state.fetchingUnitCostHistories = false;
      state.unitCostHistories = result;
    },
    [GetUnitCostHistories.rejected]: (state) => {
      state.fetchingUnitCostHistories = false;
    },
    [GetSkuUnitCostHistories.pending]: (state) => {
      state.fetchingUnitCostHistories = true;
    },
    [GetSkuUnitCostHistories.fulfilled]: (state, action) => {
      const { result } = action?.payload || {};
      state.fetchingUnitCostHistories = false;
      state.skuUnitCostHistories = result;
    },
    [GetSkuUnitCostHistories.rejected]: (state) => {
      state.fetchingUnitCostHistories = false;
    },
    [ExportFilteredProducts.pending]: (state) => {
      state.exportingData = true;
    },
    [ExportFilteredProducts.fulfilled]: (state) => {
      state.exportingData = false;
    },
    [ExportFilteredProducts.rejected]: (state) => {
      state.exportingData = false;
    },
    [ExportFilteredSKUs.pending]: (state) => {
      state.exportingData = true;
    },
    [ExportFilteredSKUs.fulfilled]: (state) => {
      state.exportingData = false;
    },
    [ExportFilteredSKUs.rejected]: (state) => {
      state.exportingData = false;
    },
    [ExportSkuMapping.pending]: (state) => {
      state.exportingData = true;
    },
    [ExportSkuMapping.fulfilled]: (state) => {
      state.exportingData = false;
    },
    [ExportSkuMapping.rejected]: (state) => {
      state.exportingData = false;
    },
    [SubmitListingsFeed.pending]: (state) => {
      state.submittingListingsFeed = true;
    },
    [SubmitListingsFeed.fulfilled]: (state) => {
      state.submittingListingsFeed = false;
    },
    [SubmitListingsFeed.rejected]: (state) => {
      state.submittingListingsFeed = false;
    },
    [GetListingFeedStatus.fulfilled]: (state, action) => {
      const { statusMap } = action?.payload || {};
      if (statusMap) state.listingStatuses = { ...state.listingStatuses, ...statusMap };
    },
    [ExportFilteredVendorItems.pending]: (state) => {
      state.exportingData = true;
    },
    [ExportFilteredVendorItems.fulfilled]: (state) => {
      state.exportingData = false;
    },
    [ExportFilteredVendorItems.rejected]: (state) => {
      state.exportingData = false;
    },
  }
})

const { reducer, actions } = threeLayerProducts;

export const {
  removeMappedItem,
  updateMappedQuantity,
  clearField
} = actions;

export default reducer;
